import {Component, OnDestroy, OnInit} from '@angular/core';
import {colors} from '../../../colors.const';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {CoreTranslationService} from '../../../../@core/services/translation.service';
import {DashboardService} from '../../../core/service/dashboard.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {GetChartResponse} from '../../../core/responses/GetChartResponse';
import {AuthenticationService} from '../../../core/service';
import {OrderOnCategory, OrdersOnCategoriesResponse,} from '../../../core/responses/OrdersOnCategoriesResponse';
import {User} from '../../../core/models';
import {ActivatedRoute, Router} from '@angular/router';
import {BenefitHistoryService} from '../../../core/service/benefit-history.service';
import {GetHistoryOrdersMinimalRequest} from '../../../core/requests/GetHistoryOrdersRequest';
import {GetHistoryOrdersResponse} from '../../../core/responses/GetHistoryOrdersResponse';
import {OrdersHistory} from '../../../core/models/orders-history';
import {
  BenefitType,
  BudgetType,
  ORDER_STATUS_LABEL,
  OrderStatus,
  PRICING_PLAN_LABEL,
  PricingPlan
} from '../../../core/helpers/constants';
import {SubdomainInfo} from 'app/core/models/subdomain-info';
import {BalanceService} from 'app/core/service/balance.service';
import {CoreMediaService} from '@core/services/media.service';
import {MediaObserver} from '@angular/flex-layout';
import {OrdinalPipe} from '../../../core/helpers/ordinal.pipe';
import {LocalizedDatePipe} from '../../../../@core/pipes/dateLocal.pipe';
import {EventModel} from '../../../core/models/EventModel';
import {UtilsService} from "../../../core/service/utils.service";
import {environment} from "../../../../environments/environment";
import {BudgetAvailabilityType} from "../../../core/helpers/enums";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [TranslatePipe, OrdinalPipe, LocalizedDatePipe],
})
export class HomeComponent implements OnInit, OnDestroy {
  // Color Variables
  private successColorShade = '#28dac6';
  private tooltipShadow = 'rgba(0, 0, 0, 0.25)';
  private labelColor = '#6e6b7b';
  private grid_line_color = 'rgba(200, 200, 200, 0.2)'; // RGBA color helps in dark layout
  public currentDate: string;
  public noChartData = false;
  public orderStatuses = OrderStatus;
  // Bar Chart
  public barChart = {
    chartType: 'bar',
    datasets: [],
    labels: [],
    options: {
      elements: {
        rectangle: {
          borderWidth: 2,
          borderSkipped: 'bottom',
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      responsiveAnimationDuration: 500,
      legend: {
        display: false,
      },
      tooltips: {
        // Updated default tooltip UI
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowBlur: 8,
        shadowColor: this.tooltipShadow,
        backgroundColor: colors.solid.white,
        titleFontColor: colors.solid.black,
        bodyFontColor: colors.solid.black,
      },
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              display: true,
              color: this.grid_line_color,
              zeroLineColor: this.grid_line_color,
            },
            scaleLabel: {
              display: true,
            },
            ticks: {
              fontColor: this.labelColor,
            },
          },
        ],
        yAxes: [
          {
            display: true,
            gridLines: {
              color: this.grid_line_color,
              zeroLineColor: this.grid_line_color,
            },
            ticks: {
              min: 0,
              fontColor: this.labelColor,
              callback: function(value) {
                return Math.round(value);
              },
            },
          },
        ],
      },
    },
    legend: false,
  };
  public isMobile = false;

  private ngUnsubscribe = new Subject<void>();
  public dashboard;
  public subdomain = 'default';
  public showBudgets: boolean;
  manualLoadTransport: number;
  manualLoadProfessionalDevelopment: number;
  bigText: string;
  private companySub: any;
  protected hasActiveEvent = false;
  protected eventInfo = {
    hasActiveEvent: false,
    startDate: null,
    endDate: null,
    providerId: 0,
    eventId: 0
  };
  private companyEvents: Array<EventModel>;
  public pendingCashbackAmount: number = 0;

  /**
   *
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    private _translationService: TranslateService,
    private dashboardService: DashboardService,
    private balanceService: BalanceService,
    private orderHistoryService: BenefitHistoryService,
    private authService: AuthenticationService,
    private coreMediaService: CoreMediaService,
    private mediaObserver: MediaObserver,
    private route: ActivatedRoute,
    private router: Router,
    private utilService: UtilsService
  ) {
    /// / this._coreTranslationService.translate(english, romanian);
    this.subdomain = localStorage.getItem('currentUserSubdomainMybenefits');
  }

  public contentHeader: object;
  public radioModel = 1;
  public userDashboardInfo: User;
  public userCompanyInfo: SubdomainInfo;
  public orderOnCategories: Array<OrderOnCategory> = [];
  public top5BenefitsOrders: Array<OrdersHistory> = [];
  public totalAmountBalance: number;
  private userSub: any;
  public faqLink = '';
  public faqLinkIsSet = false;


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this.faqLink = environment.FAQ_URL;
    this.faqLinkIsSet = this.faqLink && this.faqLink.length > 0 && this.faqLink.startsWith("https");
    this.getCurrentDate();
    this._translationService.onLangChange.subscribe(() => {
      this.getCurrentDate();
      this.updateEventInfo();
    });
    this.contentHeader = {
      headerTitle: 'Home',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/',
          },
          {
            name: 'Sample',
            isLink: false,
          },
          {
            name: 'Charts & Maps',
            isLink: true,
            link: '/',
          },
          {
            name: 'Chartjs',
            isLink: false,
          },
        ],
      },
    };

    // If we already have company data, skip subscribing; we need it to check if the user has flexible benefits or not
    if (this.authService.currentUserCompanyInfoValue && this.authService.currentUserCompanyInfoValue.companyHrEmail) {
      this.userCompanyInfo = this.authService.currentUserCompanyInfoValue;
      this.userCompanyInfo.actualBalanceLoadDay = this.userCompanyInfo.balanceLoadDay;

      if (this.userCompanyInfo.loadDayType === 1) {
        this.utilService.getNthWorkingDay(this.userCompanyInfo.balanceLoadDay, new Date()).subscribe({
          next: response => {
            this.userCompanyInfo.actualBalanceLoadDay = new Date(response.responseObject).getDate();

            if (this.userCompanyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed) {
              const properties = [
                {
                  value: this.userCompanyInfo.budgetAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.budgetAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.mealTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.mealTicketsAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.tourismTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.tourismTicketsAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.culturalTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.culturalTicketsAvailabilityInDays = v
                }
              ];

              properties.forEach(p => this.updateWorkingDay(p.value, p.setter));
            }
          }
        });
      }

      if (this.userCompanyInfo.hasCashbackBudget) {
        this.dashboardService
          .getPendingCashback()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: value => {
              this.pendingCashbackAmount = value;
            },
            error: err => {}
          });
      }

      this.showBudgets = this.userCompanyInfo.hasFlexibleBenefits &&
        (this.userCompanyInfo.hasTransportBudget || this.userCompanyInfo.hasProfessionalDevelopmentBudget || this.userCompanyInfo.hasCashbackBudget !== null);

      if (this.userCompanyInfo.hasFlexibleBenefits) {
        this.subscribeToUserBudgetChanges();
        this.getChartInfo();
        this.ordersOnCategories();
        this.topBenefitsOrders();
      }
    } else {
      this.authService.currentUserCompanyInfo.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: value => {
            this.userCompanyInfo = value;
            this.userCompanyInfo.actualBalanceLoadDay = this.userCompanyInfo.balanceLoadDay;

            if (this.userCompanyInfo.loadDayType === 1) {
              this.utilService.getNthWorkingDay(this.userCompanyInfo.balanceLoadDay, new Date()).subscribe({
                next: response => {this.userCompanyInfo.actualBalanceLoadDay = new Date(response.responseObject).getDate()}
              });
            }

            if (this.userCompanyInfo.hasCashbackBudget) {
              this.dashboardService
                .getPendingCashback()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                  next: value => {
                    this.pendingCashbackAmount = value;
                  },
                  error: err => {}
                });
            }

            this.showBudgets = this.userCompanyInfo.hasFlexibleBenefits && (this.userCompanyInfo.hasTransportBudget || this.userCompanyInfo.hasProfessionalDevelopmentBudget);
            if (this.userCompanyInfo.hasFlexibleBenefits) {
              this.subscribeToUserBudgetChanges();
              this.getChartInfo();
              this.ordersOnCategories();
              this.topBenefitsOrders();
            }
          }
        });
    }
    this.subscribeToScreenChanges();
    this.dashboardService.getCompanyEvents(this.subdomain).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: value => {
        if (value.responseObject && value.responseObject.length > 0) {
          const giftVouchers = value.responseObject[0].benefits.filter(b => b.benefitType === BenefitType.GiftVoucher);
          this.eventInfo.hasActiveEvent = giftVouchers.length > 0 && this.userDashboardInfo.numberOfGiftTickets > 0;
          this.eventInfo.startDate = this.getSimpleDate(value.responseObject[0].startDate);
          this.eventInfo.endDate = this.getSimpleDate(value.responseObject[0].endDate);
          this.eventInfo.providerId = giftVouchers[0].providerId;
          this.eventInfo.eventId = value.responseObject[0].id;
          this.companyEvents = value.responseObject;
        }
      },
      error: err => {}
    });
  }

  private updateWorkingDay(
    days: number,
    setter: (newDate: number) => void
  ) {
    this.utilService.getNthWorkingDay(days, new Date()).subscribe({
      next: response => {
        setter(new Date(response.responseObject).getDate());
      }
    });
  }

  private getSimpleDate(date) {
    if (!date) {
      return;
    }
    const lang = this._coreTranslationService.getActiveLang();
    if (lang === 'ro') {
      return new Date(date).toLocaleString(lang, {
        month: 'long',
        day: 'numeric'
      });
    } else {
      const day = new Date(date).getDate();
      const month = new Date(date).toLocaleString(lang, { month: 'long' });

      const getEnglishOrdinal = (value: number): string => {
        const remainder = value % 100;

        if (remainder >= 11 && remainder <= 13) {
          return value + 'th';
        }

        switch (value % 10) {
          case 1:
            return value + 'st';
          case 2:
            return value + 'nd';
          case 3:
            return value + 'rd';
          default:
            return value + 'th';
        }
      };

      return `${month} ${getEnglishOrdinal(day)}`;
    }
  }

  subscribeToUserBudgetChanges() {
    this.authService.currentUserInfo
      .subscribe((x) => {
        this.userDashboardInfo = x;
        this.getTotalAmount(this.userDashboardInfo);
        if (this.authService.isDirty) {
          this.balanceService.getLastManualBalance(this.userDashboardInfo.id, BudgetType.Transport).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data) => {
              this.manualLoadTransport = data.responseObject.amount;
            }
          );
          this.balanceService.getLastManualBalance(this.userDashboardInfo.id, BudgetType.ProfessionalDevelopment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data) => {
              this.manualLoadProfessionalDevelopment = data.responseObject.amount;
            }
          );
          this.authService.isDirty = false;
        }
      });
  }

  getTotalAmount(userDashboardInfo: User) {
    this.totalAmountBalance = userDashboardInfo.totalAmount;
    if (this.userCompanyInfo.hasTransportBudget) {
      this.totalAmountBalance += userDashboardInfo.totalAmountTransport;
    }
    if (this.userCompanyInfo.hasProfessionalDevelopmentBudget) {
      this.totalAmountBalance += userDashboardInfo.totalAmountProfessionalDevelopment;
    }
    if (this.userDashboardInfo.totalAmountCashback !== null) {
      this.totalAmountBalance += userDashboardInfo.totalAmountCashback;
    }
    this.bigText = this.totalAmountBalance.toFixed(2) + ' RON';
  }

  changeLang(val) {
    this._coreTranslationService.changeLang(val);
  }

  public getChartInfo() {
    this.dashboardService
      .getChartInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetChartInfoSuccess(data);
        },
        (error) => {
          this.onGetChartInfoFail(error);
        }
      );
  }

  public onGetChartInfoSuccess(data: GetChartResponse) {
    if (data.responseObject && data.responseObject.length > 0) {
      const chartData = data.responseObject.map((e) => e.totalAmount);
      const chartLabels = data.responseObject.map((e) => {
        const date = e.groupingMonth.split('.');
        if (date.length === 2) {
          const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ];
          const month = date[0];
          return months[parseInt(month, 10) - 1];
        }
      });
      this.barChart.datasets = [
        {
          data: chartData,
          backgroundColor: this.successColorShade,
          borderColor: 'transparent',
          hoverBackgroundColor: this.successColorShade,
          hoverBorderColor: this.successColorShade,
        },
      ];
      this.barChart.labels = chartLabels;
    } else {
      this.noChartData = true;
    }
  }

  public onGetChartInfoFail(error: HttpErrorResponse) { }

  public ordersOnCategories() {
    const userId = this.authService.currentUserValue.userId;
    this.dashboardService
      .ordersOnCategories(userId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onOrdersOnCategoriesSuccess(data);
        },
        (error) => {
          this.onOrdersOnCategoriesFail(error);
        }
      );
  }

  public onOrdersOnCategoriesSuccess(data: OrdersOnCategoriesResponse) {
    this.orderOnCategories = data.responseObject;
  }

  public onOrdersOnCategoriesFail(error: HttpErrorResponse) { }

  public topBenefitsOrders() {
    const params: GetHistoryOrdersMinimalRequest = {
      minimalData: true,
      paginationCriteria: {
        start: 0,
        limit: 5,
      },
    };
    this.authService.currentUserInfo
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.orderHistoryService
          .getAllOrdersHistoryMinimal(this.userDashboardInfo.id, params)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (data: GetHistoryOrdersResponse) => {
              this.onTopBenefitsOrdersSuccess(data);
            },
            error: (err) => {
              this.onTopBenefitsOrdersFail(err);
            }
          });
      });
  }

  public onTopBenefitsOrdersSuccess(data: GetHistoryOrdersResponse) {

    this.top5BenefitsOrders = data.responseObject.data.map(e => {
        return {
          ...e,
          orderStatusLabel: ORDER_STATUS_LABEL[e.orderStatus]
        }
      }
    );
  }

  public onTopBenefitsOrdersFail(error: HttpErrorResponse) { }

  private getCurrentDate() {
    const lang = this._coreTranslationService.getActiveLang();
    this.currentDate = new Date().toLocaleString(lang, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  subscribeToScreenChanges() {
    this.coreMediaService.onMediaUpdate.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        const isSmall = this.mediaObserver.isActive('bs-lt-lg');
        this.isMobile = isSmall === true;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openGiftVouchersPage() {
    this.router.navigate([
      '/' + this.subdomain + '/event-supplier-info/' + this.eventInfo.eventId,
    ]);

  }

  private updateEventInfo() {
    if (this.eventInfo.hasActiveEvent && this.companyEvents && this.userDashboardInfo.numberOfGiftTickets > 0) {
      this.eventInfo.startDate = this.getSimpleDate(this.companyEvents[0].startDate);
      this.eventInfo.endDate = this.getSimpleDate(this.companyEvents[0].endDate);
    }
  }

  readonly PricingPlan = PricingPlan;
  protected readonly PRICING_PLAN_LABEL = PRICING_PLAN_LABEL;
  isCollapsed1: boolean = false;
  protected readonly BudgetAvailabilityType = BudgetAvailabilityType;
}
